import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {first, takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {Department} from '../../../shared/interface/department';
import {DepartmentService} from '../../../shared/services/department.service';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {User} from '../../../shared/interface/user';
import {FormBuilder, FormGroup} from '@angular/forms';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-department-details',
  templateUrl: './department-details.component.html',
  styleUrls: ['./department-details.component.scss']
})
export class DepartmentDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @ViewChild(MatPaginator) paginator: MatPaginator;

  departmentId: string;
  departmentObject?: Department;
  department: ReplaySubject<Department> = new ReplaySubject<Department>(1);
  employeesDataSource: MatTableDataSource<User>;
  modify = false;
  displayedColumns: string[] = ['username', 'active', 'firstName', 'lastName', 'phone', 'email', 'position'];
  supervisorPermissionsForm: FormGroup;
  employeePermissionsForm: FormGroup;

  supervisorApplicationPermissionsForm: FormGroup;
  employeeApplicationPermissionsForm: FormGroup;

  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private departmentService: DepartmentService,
    private snack: MatSnackBar,
    private fb: FormBuilder,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.supervisorPermissionsForm = fb.group({});
    this.employeePermissionsForm = fb.group({});
    this.employeesDataSource = new MatTableDataSource<User>([]);

    this.supervisorApplicationPermissionsForm = this.fb.group({});
    this.employeeApplicationPermissionsForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.departmentId = params.id;
        this.loadDepartment();
        this.loadEmployees();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.employeesDataSource.paginator = this.paginator;
  }

  loadDepartment(): void {
    this.departmentService.get(this.departmentId).subscribe((department: Department) => {
      this.department.next(department);
      this.departmentObject = department;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych działu', error.status.toString(), {
        duration: 2000
      });
    });
  }

  loadEmployees(): void {
    this.departmentService.getEmployeeListSubject()
      .subscribe((response: ListResponse<User>) => {
        this.employeesDataSource.data = response.items;
      });
    this.departmentService.loadEmployeeList(this.departmentId);
  }

  saveSupervisorPermissions(): void {
    this.departmentService.updateSupervisorPermissions(this.departmentObject.uuid, this.supervisorPermissionsForm.getRawValue())
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano uprawnienia', '', {
          duration: 2000,
        });

      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas aktualizacji uprawnień wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      })
    ;
  }

  saveEmployeePermissions(): void {
    this.departmentService.updateEmployeePermissions(this.departmentObject.uuid, this.employeePermissionsForm.getRawValue())
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano uprawnienia', '', {
          duration: 2000,
        });

      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas aktualizacji uprawnień wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      })
    ;
  }
  getApplicationPermissionsByAssignmentType(assignmentType: 'employee' | 'supervisor'): any {
    const result = {};

    if (!this.departmentObject?.applicationPermissions) {
      return result;
    }

    this.departmentObject.applicationPermissions
      .filter((item: any) => item.assignmentType === assignmentType)
      .forEach((item: any) => {
        result[item.applicationKey] = item.permissions || {};
      });

    return result;
  }
  saveSupervisorApplicationPermissions(): void {
    if (!this.departmentObject || !this.supervisorApplicationPermissionsForm) {
      return;
    }

    const payload = this.supervisorApplicationPermissionsForm.getRawValue();

    this.departmentService.updateApplicationPermissions(
      this.departmentObject.uuid,
      'supervisor',
      payload
    )
      .pipe(first())
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano uprawnienia aplikacji przełożonego', '', {
          duration: 2000,
        });

        this.loadDepartment();
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas aktualizacji uprawnień aplikacji wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      });
  }

  saveEmployeeApplicationPermissions(): void {
    if (!this.departmentObject || !this.employeeApplicationPermissionsForm) {
      return;
    }

    const payload = this.employeeApplicationPermissionsForm.getRawValue();

    this.departmentService.updateApplicationPermissions(
      this.departmentObject.uuid,
      'employee',
      payload
    )
      .pipe(first())
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano uprawnienia aplikacji pracownika', '', {
          duration: 2000,
        });

        this.loadDepartment();
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas aktualizacji uprawnień aplikacji wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      });
  }
}
